import reader from "@vp/ctc-reader";

const isTreatmentEnabled = (treatmentId) => {
  return reader.isTreatmentEnabled(treatmentId);
};

export default {
  isTreatmentEnabled,
};
